import { StickerFrame, type StickerArtProps } from './StickerFrame';

export function Space(props: StickerArtProps) {
  return (
    <StickerFrame background="#312e81" {...props}>
      <circle cx="32" cy="33" r="11" fill="#fde68a" />
      <ellipse
        cx="32"
        cy="33"
        rx="20"
        ry="6"
        fill="none"
        stroke="#ffffff"
        strokeWidth="3"
        transform="rotate(-20 32 33)"
      />
      <circle cx="17" cy="18" r="2.5" fill="#ffffff" />
      <circle cx="47" cy="17" r="2" fill="#ffffff" />
      <circle cx="45" cy="49" r="2.5" fill="#ffffff" />
    </StickerFrame>
  );
}
